import type { FaireProductEntity } from "../../entity_types/product";

export const p_bwdvm5vo: FaireProductEntity = {
  token: "p_bwdvm5vo",
  type: "product",
  name: "Pancake Plant Thank You Boxed Card Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/be6e1cf8697107858005325af17cab4f141ef73fd0becc2f415dbb8ce6c57a70.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/ab6c0b4fa40b86c23bfd20d5875c7be61667ba4a2a86bc84123d8f135ca1ed2c/1528385648.png",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/35b9ee4ea47fb33719ef4ab8a7f59d98db5bfdb8465b3edfec7d23dcd56f02d5/1528385646.png",
  ],
  priceDollars: 11,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:18.907Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
